export default __webpack_public_path__ + "static/media/paleta.85e16271.png";